<template>
  <b-row class="wlp-navigation no-gutters">
    <b-col cols="12">
      <b-row class="no-gutters">
        <!--left-->
        <b-col class="left-sec order-lg-1 order-2" lg="6" cols="12">
          <b-row class="left-nav-sec no-gutters">
            <div class="info-btn-section display-lg">
              <div class="info-btn-div reduce-padding">
                <button
                  @click="moreInfo"
                  v-show="show(navButtons, 'info')"
                  class="info-btn btn"
                >
                  <span class="info-icon"></span>
                  <span class="info-text">
                    {{ $t("navigation.more-information") }}</span
                  >
                </button>
              </div>
            </div>
            <div class="link-btns-section">
              <b-row class="no-gutters">
                <b-col
                  md="6"
                  cols="12"
                  class="left-link-btn order-1 reduce-padding"
                  :class="{
                    'without-info': !show(navButtons, 'info'),
                    'no-ref': !show(navButtons, 'references'),
                  }"
                >
                  <button
                    @click="study"
                    v-show="show(navButtons, 'references')"
                    class="link-btn ref-btn btn stdbtn"
                    :class="{
                      'without-info': !show(navButtons, 'info'),
                      'ref-btn-sp': $i18n.locale == 'sp',
                      'hide-btn-md': btn4Absent && !btn5Absent,
                    }"
                  >
                    <span class="link-text smstud">{{
                      $t("navigation.ref")
                    }}</span>
                  </button>
                  <button
                    :class="{
                      'only-tnc': !show(navButtons, 'references'),
                      'terms-btn-sp': $i18n.locale == 'sp',
                      'link-btn-sp': $i18n.locale == 'sp',
                      'display-md': btn4Absent && !btn5Absent,
                      'left-float': btn4Absent && !btn5Absent,
                      'hide-tnc': !(btn4Absent && !btn5Absent),
                    }"
                    @click="$router.push('termsConditions')"
                    v-show="show(navButtons, 'tnc')"
                    class="link-btn terms-btn btn"
                  >
                    <span class="link-text">{{ $t("navigation.terms") }}</span>
                  </button>
                </b-col>
                <b-col
                  md="6"
                  cols="12"
                  class="right-link-btn order-2 reduce-padding"
                >
                  <button
                    :class="{
                      'without-info': !show(navButtons, 'info'),
                      'without-info-sp': $i18n.locale == 'sp',
                      'terms-btn-sp': $i18n.locale == 'sp',
                      'link-btn-sp': $i18n.locale == 'sp',
                      'only-tnc': !show(navButtons, 'references'),
                      'only-tnc-sp':
                        $i18n.locale == 'sp' && !show(navButtons, 'references'),
                      'hide-btn-md':
                        (btn4Absent && !btn5Absent) ||
                        (btn4Absent && btn5Absent),
                    }"
                    @click="$router.push('termsConditions')"
                    v-show="show(navButtons, 'tnc')"
                    class="link-btn terms-btn btn"
                  >
                    <span class="link-text">{{ $t("navigation.terms") }}</span>
                  </button>
                </b-col>
              </b-row>
            </div>
          </b-row>
        </b-col>
        <!--right-->
        <b-col class="right-sec order-lg-2 order-1" lg="6" cols="12">
          <b-row class="right-nav-sec no-gutters">
            <b-col
              lg="4"
              md="6"
              cols="12"
              class="third-btn reduce-padding order-lg-1 order-3"
            >
              <button
                @click="$router.push('menu')"
                v-show="show(navButtons, 'menu')"
                class="forward-btn btn"
                :class="{ 'forward-btn-sp': $i18n.locale == 'sp' }"
              >
                <span class="btn-text nxt-text">{{
                  $t("navigation.menu")
                }}</span>
              </button>
              <button
                @click="summary()"
                v-show="show(navButtons, 'summary')"
                class="forward-btn btn"
                :class="{ 'forward-btn-sp': $i18n.locale == 'sp' }"
              >
                <span class="btn-text summary-text">{{
                  $t("navigation.summary")
                }}</span>
              </button>
              <button
                @click="moreInfo"
                v-show="show(navButtons, 'info') && btn3Absent"
                class="info-btn btn"
                :class="{ 'display-md': btn3Absent }"
              >
                <span class="info-icon"></span>
                <span class="info-text">{{
                  $t("navigation.more-information")
                }}</span>
              </button>
            </b-col>
            <b-col
              lg="4"
              md="6"
              cols="12"
              class="main-btns-section reduce-padding order-1"
            >
              <b-row class="no-gutters">
                <b-col class="left-btn reduce-padding">
                  <button
                    @click="back()"
                    v-show="
                      (show(navButtons, 'back') ||
                        show(navButtons, 'previous')) &&
                      !isEmail
                    "
                    class="back-btn btn"
                    :class="{ 'back-btn-sp': $i18n.locale == 'sp' }"
                  >
                    <span
                      class="back-icon"
                      :class="{ 'back-icon-sp': $i18n.locale == 'sp' }"
                    ></span>
                    <span
                      class="btn-text"
                      :class="{ 'nxt-text-sp': $i18n.locale == 'sp' }"
                      >{{ $t("navigation.back") }}</span
                    >
                  </button>
                </b-col>
              </b-row>
            </b-col>
            <b-col
              lg="4"
              md="6"
              cols="12"
              class="main-btns-section reduce-padding order-2"
            >
              <b-row class="no-gutters">
                <b-col class="right-btn reduce-padding">
                  <button
                    @click="next"
                    v-show="show(navButtons, 'next')"
                    class="forward-btn btn"
                    :class="{ 'forward-btn-sp': $i18n.locale == 'sp' }"
                  >
                    <span
                      class="next-icon"
                      :class="{ 'next-icon-sp': $i18n.locale == 'sp' }"
                    ></span>
                    <span
                      class="btn-text nxt-text"
                      :class="{ 'nxt-text-sp': $i18n.locale == 'sp' }"
                      >{{ $t("navigation.next") }}</span
                    >
                  </button>
                  <button
                    @click="$router.push('menu')"
                    v-show="show(navButtons, 'menu2')"
                    class="forward-btn btn"
                  >
                    <span class="btn-text nxt-text">{{
                      $t("navigation.menu")
                    }}</span>
                  </button>
                  <button
                    @click="back()"
                    v-show="isEmail && show(navButtons, 'previous')"
                    class="back-btn btn"
                    :class="{ 'back-btn-sp': $i18n.locale == 'sp' }"
                  >
                    <span class="back-icon"></span>
                    <span
                      class="btn-text"
                      :class="{ 'nxt-text-sp': $i18n.locale == 'sp' }"
                      >{{ $t("navigation.back") }}</span
                    >
                  </button>
                </b-col>
              </b-row>
              <!--</div>-->
            </b-col>

            <b-col md="6" cols="12" class="order-4 display-md">
              <button
                @click="moreInfo()"
                v-show="show(navButtons, 'info')"
                class="info-btn btn"
                :class="{ 'hide-btn-md': btn3Absent }"
              >
                <span class="info-icon"></span>
                <span class="info-text">{{
                  $t("navigation.more-information")
                }}</span>
              </button>
              <b-col
                lg="6"
                cols="12"
                class="left-link-btn order-1 reduce-padding"
                v-show="btn4Absent && !btn5Absent"
              >
                <button
                  @click="study"
                  v-show="show(navButtons, 'references')"
                  class="link-btn ref-btn btn"
                >
                  <span class="link-text smstud">{{
                    $t("navigation.ref")
                  }}</span>
                </button>
              </b-col>
              <b-col
                lg="6"
                cols="12"
                class="right-link-btn order-2 reduce-padding"
                v-show="btn4Absent && btn5Absent"
              >
                <button
                  :class="{ 'only-tnc-ref': !show(navButtons, 'references') }"
                  @click="$router.push('termsConditions')"
                  v-show="show(navButtons, 'tnc')"
                  class="link-btn terms-btn btn"
                >
                  <span class="link-text">{{ $t("navigation.terms") }}</span>
                </button>
              </b-col>
            </b-col>
          </b-row>
        </b-col>
      </b-row>
    </b-col>
  </b-row>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  name: "wlpNavigation",
  components: {},
  data() {
    return {
      screens: [
        "/",
        "intendedUse",
        "menu",
        "cancer",
        "dyslipidemia",
        "hypertension",
        "pcos",
        "osteoarthritis",
        "type2Diabetes",
        "lifeLost",
        "summary1",
        "summary2",
      ],
    };
  },
  props: {
    navButtons: {
      type: Array,
    },
    btnClickHandler: {
      type: Function,
    },
    currentScreen: {
      type: Number,
    },
    showResults: {
      type: Boolean,
    },
    nextHandler: {
      type: Function,
    },
    tagHandler: {
      type: Function,
    },
    isEmail: {
      type: Boolean,
      default: false,
    },
    btn3Absent: {
      type: Boolean,
      default: false,
    },
    btn4Absent: {
      type: Boolean,
      default: false,
    },
    btn5Absent: {
      type: Boolean,
      default: false,
    },
  },

  computed: {
    ...mapGetters("userData", ["userData"]),
  },

  mounted: function () {},

  methods: {
    show: function (buttonsArray, button) {
      return !(buttonsArray.indexOf(button) == -1);
    },
    summary: function () {
      if (this.btnClickHandler()) {
        this.$router.push("summary1");
      }
    },

    next: function () {
      var nextScreen;
      if (this.btnClickHandler === undefined || this.btnClickHandler()) {
        if (this.screens[this.currentScreen + 1] == "pcos") {
          nextScreen = this.userData.gender === "Male" ? this.screens[this.currentScreen + 2]
              : this.screens[this.currentScreen + 1];
        } else {
          nextScreen = this.screens[this.currentScreen + 1];
        }
        this.$router.push(nextScreen);
      }
    },

    back: function () {
      if (this.show(this.navButtons, "back")) {
        var backScreen = this.screens[this.currentScreen - 1];
        if (this.screens[this.currentScreen - 1] == "pcos") {
          backScreen =
            this.userData.gender === "Male"
              ? this.screens[this.currentScreen - 2]
              : this.screens[this.currentScreen - 1];
        }
        setTimeout(() => {
          this.$router.push(backScreen);
        }, 0);
      } else {
        this.$router.go(-1);
      }
    },

    moreInfo: function () {
      console.log("curr screen: " + this.screens[this.currentScreen]);
      switch (this.currentScreen) {
        case 1:
          this.userData.infoAnchor = "";
          break;

        default:
          this.userData.infoAnchor = this.screens[this.currentScreen];
      }
      this.$router.push("moreInfo");
    },

    study: function () {
      console.log("curr screen: " + this.screens[this.currentScreen]);
      switch (this.currentScreen) {
        case 1:
        case 11:
        case 12:
          console.log("11 12");
          this.userData.refAnchor = "";
          break;

        case 20:
          this.userData.refAnchor = "info";
          break;

        default:
          console.log("default");
          this.userData.refAnchor = this.screens[this.currentScreen];
      }
      this.$router.push("references");
    },
  },
};
</script>


<style lang="scss" scoped>
</style>
